"use client";

import styled from "styled-components";
import Image from "../image";

export const BoxUserName = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ImageUser = styled(Image)<{ $size?: number }>`
  width: ${(p) => (p.$size ? `${p.$size}px` : "35px")};
  height: ${(p) => (p.$size ? `${p.$size}px` : "35px")};
  border-radius: 100px;

  @media (min-width: 768px) {
    height: ${(p) => (p.$size ? `${Math.round(p.$size * 1.4)}px` : "55px")};
    width: ${(p) => (p.$size ? `${Math.round(p.$size * 1.4)}px` : "55px")};
  }
`;

export const UserName = styled.span`
  font-family: "Roboto Medium";
  font-size: 15px;
  color: var(--textLight);
`;
